import React from 'react';
import PageHeader from '@components/Shared/PageHeader/PageHeader';
import { GenerateContractsContainer } from '@containers/GenerateContractsContainer';
import { PageContainer } from './GenerateContracts.styles';

export default function GenerateContracts() {
  return (
    <PageContainer>
      <PageHeader 
        title="Generate Contracts" 
        description="Create legal contracts with natural language"
      />
      <GenerateContractsContainer />
    </PageContainer>
  );
};